import React from "react";
import { motion } from "framer-motion";
import { Search, Package } from "lucide-react";
import { useTranslation } from "react-i18next";

const NoResultsPrompt = ({ 
  searchText = "",
  title,
  description
}) => {
  const { t } = useTranslation();
  
  const hasSearchText = searchText && searchText.trim().length > 0;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="bg-white section rounded-lg shadow-md p-6 text-center"
    >
      <div className="flex justify-center mb-3">
        {hasSearchText ? (
          <Search className="w-12 h-12 text-gray-400" />
        ) : (
          <Package className="w-12 h-12 text-gray-400" />
        )}
      </div>
      
      <h2 className="text-lg font-semibold mb-2 text-gray-900 dark:text-gray-100">
        {title || (hasSearchText 
          ? t("products.noProductsFound") 
          : t("products.noProductsAvailable")
        )}
      </h2>
      
      {(description || hasSearchText) && (
        <p className="text-sm text-gray-600 dark:text-gray-400">
          {description || t("products.tryAdjustingSearch")}
        </p>
      )}
    </motion.div>
  );
};

export default NoResultsPrompt;
